import { render, staticRenderFns } from "./BillHeader.vue?vue&type=template&id=5e40378f&scoped=true&"
import script from "./BillHeader.vue?vue&type=script&lang=ts&"
export * from "./BillHeader.vue?vue&type=script&lang=ts&"
import style0 from "./BillHeader.vue?vue&type=style&index=0&id=5e40378f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e40378f",
  null
  
)

export default component.exports